import { gql } from "../__generated__/gql";

gql(`
    fragment AbsenceFields on Absence {
        id
        comment
        start
        end
        type
    }
`);

gql(`
    fragment BonusFields on Bonus {
        description
        amount
        invoiceAmount
    }
`);

gql(`
    fragment AuxiliarySalaryFields on AuxiliarySalary {
        description
        duration
        grossAmount
        baseAmount
        invoiceAmount
    }
`);

gql(`
    fragment EffectiveFeeFields on EffectiveFee {
        description
        amount
    }
`);

gql(`
    fragment DynamicFeeFields on DynamicFee {
        fee {
            ...MissionFeeFields
        }
       count
    }
`);

gql(`
    fragment DynamicDeductionFields on DynamicDeduction {
        deduction {
            ...MissionDeductionFields
        }
       count
    }
`);

gql(`
    fragment TrackedDurationBreakdownFields on TrackedDurationBreakdownType {
        items {
            hourRate
            type
            totalDurationMinutes
        }
    }
`);

gql(`
    fragment TimeSheetFields on TimeSheet {
        id
        status
        fromDate
        toDate
        acceptedAt
        autoAcceptAt
        submittedAt
        rejectedAt
        acceptedBy
        trackedDurationBreakdown {
            ...TrackedDurationBreakdownFields
        }
        isExactTimeSheet
        totalTrackedDurationMinutes
        trackingDates {
            date
            daySchedule {
                ...DayScheduleFields                
            }            
        }
        missionInfo {
            ...MissionInfoFields
        }
        contractWeeklyDurationMinutes
    }
`);

gql(`
    fragment MissionPayrollBreakdownFields on PayrollBreakdown {
       id
       createdAt
       updatedAt
       yearMonth
       status
       startDate
       endDate
       totalWork100
       totalWork115
       totalWork125
       totalWork150
       totalWork200
       deltaWork
       totalWorkedDays
       usedVacationMinutes
       overtimePaid100
       overtimePaid125
       overtimePaidAmounts {
           payRatePercent
           minutes
           amount
       }
       usedVacationAmount
       submittedAt
       submittedBy {
           id
           avatarUrl
           firstName
           lastName
       }
       timesheets {
           ...TimeSheetFields
       }
       missionInfo {
           ...MissionInfoFields
       }
       absences {
           ...AbsenceFields
       }
       dynamicFees {
           ...DynamicFeeFields
       }
       dynamicDeductions {
           ...DynamicDeductionFields
       }
       bonuses {
           ...BonusFields
       }
       auxiliarySalaries {
           ...AuxiliarySalaryFields
       }
       effectiveFees {
            ...EffectiveFeeFields
       }
       summary {
            ...PayrollBreakdownSummaryFields
       }
        isLast
        isExtraMonth
        release13thSalary
        releases13thSalary
    }
`);

gql(`
    fragment SummaryRowFields on SummaryRow {
       productKey
       category
       description
       detailedDescription
       unitPrice
       quantity
       repetition
    }
`);

gql(`
    fragment PayrollBreakdownSummaryFields on PayrollBreakdownSummary {
       needProcessing
       rows {
           ...SummaryRowFields
       }
    }
`);

export const GET_ALL_TIMESHEETS = gql(`
    query GetAllTimeSheets($statusIn: [TimeSheetState!], $fromDate: Date, $toDate: Date) {
        getAllTimeSheets(statusIn: $statusIn, fromDate: $fromDate, toDate: $toDate) {
            count
            elements {
                ...TimeSheetFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

export const FIND_MISSION_TIMESHEETS = gql(`
    query FindMissionTimeSheets($missionId: ID!, $statusIn: [TimeSheetState!]) {
        findMissionTimeSheets(missionId: $missionId, statusIn: $statusIn, limit:100) {
            count
            elements {
                ...TimeSheetFields
            }
        }
    }
`);

export const FIND_WORKER_TIMESHEETS = gql(`
    query FindWorkerTimeSheets($workerProfileId: ID!, $statusIn: [TimeSheetState!]) {
        findWorkerTimeSheets(workerProfileId: $workerProfileId, statusIn: $statusIn, offset:0, limit:100) {
            count
            elements {
                ...TimeSheetFields
            }
        }
    }
`);
export const SUBMIT_EXACT_TIME_SHEET = gql(`
    mutation SubmitExactTimeSheet($timeSheetId: ID!, $trackingDates: [DateScheduleInput!]!) {
        submitExactTimeSheet(
            timeSheetId: $timeSheetId
            trackingDates: $trackingDates
        ) {
            id
        }
    }
`);

export const SAVE_TIME_SHEET = gql(`
    mutation SaveTimeSheet($timeSheetId: ID!, $trackingDates: [DateScheduleInput!]!) {
        saveTimeSheet(
            timeSheetId: $timeSheetId
            trackingDates: $trackingDates
        ) {
            ...TimeSheetFields
        }
    }
`);

export const ACCEPT_TIME_SHEET = gql(`
    mutation AcceptTimeSheet($timeSheetId: ID!) {
        acceptTimeSheet(timeSheetId: $timeSheetId) {
            ...TimeSheetFields
        }
    }
`);

export const REJECT_TIME_SHEET = gql(`
    mutation RejectTimeSheet($timeSheetId: ID!) {
        rejectTimeSheet(timeSheetId: $timeSheetId) {
            ...TimeSheetFields
        }
    }
`);

export const GET_DURATION_BREAKDOWN = gql(`
    query GetDurationBreakdown($trackingDates: [DateScheduleInput!]!, $missionId: ID!) {
        getDurationBreakdown(trackingDates: $trackingDates, missionId: $missionId) {
            ...TrackedDurationBreakdownFields
        }
    }
`);

export const GET_TIME_SHEET = gql(`
    query GetTimeSheet($timeSheetId: ID!) {
        getTimeSheet(timeSheetId: $timeSheetId) {
            ...TimeSheetFields
        }
    }
`);

export const FIND_MISSION_PAYROLL_BREAKDOWN = gql(`
    query FindMissionPayrollBreakdown($missionId: ID!) {
        findMissionPayrollBreakdown(missionId: $missionId, offset:0, limit:100) {
            count
            elements {
                ...MissionPayrollBreakdownFields
            }
            pageInfo {
                ...PageInfoFields
            }
        }
    }
`);

export const GET_PAYROLL_BREAKDOWN = gql(`
    query GetPayrollBreakdown($payrollBreakdownId: ID!) {
        getPayrollBreakdown(payrollBreakdownId: $payrollBreakdownId) {
            ...MissionPayrollBreakdownFields
        }
    }
`);

export const SUBMIT_PAYROLL_BREAKDOWN = gql(`
    mutation SubmitPayrollBreakdown($payrollBreakdownId: ID!, $data: PayrollBreakdownInput!) {
        submitPayrollBreakdown(payrollBreakdownId: $payrollBreakdownId, payrollBreakdownInput: $data) {
            ...MissionPayrollBreakdownFields
        }
    }
`);

export const SAVE_PAYROLL_BREAKDOWN = gql(`
    mutation SavePayrollBreakdown($payrollBreakdownId: ID!, $data: PayrollBreakdownInput!) {
        savePayrollBreakdown(payrollBreakdownId: $payrollBreakdownId, payrollBreakdownInput: $data) {
            ...MissionPayrollBreakdownFields
        }
    }
`);

export const GET_PAYROLL_BREAKDOWN_SUMMARY = gql(`
    query GetPayrollBreakdownSummary($payrollBreakdownId: ID!, $payrollBreakdownInput: PayrollBreakdownInput!) {
        getPayrollBreakdownSummary(payrollBreakdownId: $payrollBreakdownId, payrollBreakdownInput: $payrollBreakdownInput) {
            ...PayrollBreakdownSummaryFields
        }
    }
`);

export const GET_MISSION_VACATION_STATUS = gql(`
    query GetMissionVacationStatus($missionId: ID!) {
        getMissionVacationStatus(missionId: $missionId) {
            missionInfo {
                ...MissionInfoFields
            }
            contractHoursPerWeekFullTime
            contractVacationDaysFullTime
            contractVacationIndemnity
            contractVacationMinutes
            contractBaseSalary
            availableVacationAmount
            availablePendingVacationAmount
            availableVacationMinutes
            availablePendingVacationMinutes
            previousYearAvailableVacationMinutes
            currentYearTotalAllowedVacationMinutes
            accountingDate
            isVacationTracked
        }
    }
`);

export const GET_MISSION_VACATION_ACCUMULATION_MINUTES_FOR_PAYROLL_BREAKDOWN = gql(`
    query GetMissionVacationAccumulationMinutesForPayrollBreakdown($payrollBreakdownId: ID!) {
        getMissionVacationAccumulationMinutesForPayrollBreakdown(payrollBreakdownId: $payrollBreakdownId)
    }
`);

export const GET_MISSION_OVERTIME_STATUS = gql(`
    query GetMissionOvertimeStatus($missionId: ID!) {
        getMissionOvertimeStatus(missionId: $missionId) {
            missionInfo {
                ...MissionInfoFields
            }
            overtimeHourlyInvoiceAmount
            overtimeMinutes
            accountingDate
            overtimePaidAtPercent
        }
    }
`);
